export default __webpack_public_path__ + "static/media/black-friday-hero.79249ca9.svg";